import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export function useOrdererProfile(ordererId) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!ordererId) return;

    let cancelled = false;
    setLoading(true);
    setError(null);

    getDoc(doc(db, 'publicProfiles', ordererId))
      .then(snap => {
        if (cancelled) return;
        if (!snap.exists()) {
          setError('not_found');
          setProfile(null);
        } else {
          setProfile(snap.data());
        }
      })
      .catch(err => {
        if (cancelled) return;
        setError(err.message ?? 'fetch_error');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [ordererId]);

  return { profile, loading, error };
}
